import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function errorReducer(state = initialState.errorMessage, action) {
	switch (action.type) {
		case types.ADD_ERROR:
			return action.body;

		case types.CLEAR_ERRORS:
			return "";

		default:
			return state;
	}
}
